/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ReactComponent as LinkedInIcon } from "cms/assets/icons/linked-in-logo.svg";
import { ReactComponent as FacebookIcon } from "cms/assets/icons/facebook-logo.svg";
import { ReactComponent as YouTubeIcon } from "cms/assets/icons/youtube-logo.svg";
import { ReactComponent as NewsletterIcon } from "cms/assets/icons/newsletter.svg";

function FooterInTouch () {
    //TODO: SC-2340 - Fill out href URLs
    return (
        <div className="footer-location footer-column">
            <h3 className='footer-column-title'>Stay in Touch</h3>
            <ul className="footer-column-content">
                <li>
                    <p>
                        Stay on top of events, important<br />
                        announcements, alerts and more
                    </p>
                </li>
                <li>
                    <LinkedInIcon alt="LinkedIn logo"/>
                    <a href="">LinkedIn</a>
                </li>
                <li>
                    <FacebookIcon alt="Facebook logo"/>
                    <a href="">Facebook</a>
                </li>
                <li>
                    <YouTubeIcon alt="YouTube logo" />
                    <a href="">YouTube</a>
                </li>
                <li>
                    <NewsletterIcon alt="newsletter icon" />
                    <a href="">Subscribe to updates</a>
                </li>
            </ul>
        </div>
    );
}

export { FooterInTouch };
